import { useState } from "react";
import { GALLERY_PHOTOS } from "@/lib/constants";
import { Lightbox, LightboxImage } from "@/components/ui/lightbox";

export default function GalleryGrid() {
  const [selectedImage, setSelectedImage] = useState<{ src: string; title: string } | null>(null);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {GALLERY_PHOTOS.map((photo) => (
          <div 
            key={photo.id}
            className="gallery-item overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 aspect-square relative"
          >
            <img
              src={photo.src}
              alt={photo.title}
              className="w-full h-full object-cover"
            />
            <div 
              className="absolute inset-0 bg-[#4A1D6E]/0 hover:bg-[#4A1D6E]/20 transition-colors duration-300 cursor-pointer"
              onClick={() => setSelectedImage({ src: photo.src, title: photo.title })}
            ></div>
          </div>
        ))}
      </div>

      <Lightbox 
        isOpen={!!selectedImage} 
        onClose={() => setSelectedImage(null)}
      >
        {selectedImage && (
          <LightboxImage 
            src={selectedImage.src} 
            alt={selectedImage.title} 
          />
        )}
      </Lightbox>
    </>
  );
}
